import React from 'react';
import { get } from 'lodash';
import Tooltip from '../components/Fields/Tooltip/Tooltip';
import {
  SCORE_MAX,
  SCORE_GOOD,
  SCORE_MEDIUM,
  SCORE_POOR,
  SCORE_BAD
} from '../consts/conditionColors';


/**
 * Function that takes sortData and creates api-friendly
 * sort params
 * @param {{ order: 'asc'|'desc', sortBy: string }} sortData
 * @returns {String} - parsed sort params
 */
export const getSortParams = (sortData) => {
  if (sortData && get(sortData, 'order')) {
    const sortBy = get(sortData, 'sortBy');
    const order = get(sortData, 'order');
    return {
      [`sort[${sortBy}]`]: order,
    };
  }
  return null;
};

// eslint-disable-next-line max-params
export const handleShowOffer = (id, history, match, whichFolder) => {
  const offerUrl = `${match.url}/details/${id}`;
  history.push({
    pathname: offerUrl,
    state: { whichFolder, },
  });
};

// eslint-disable-next-line complexity
export const scoreColors = (score, isMaxScoreFive) => {
  const isScoreMaximum = ((score <= 100 && score >= 80) || (isMaxScoreFive && score === 5));
  const isScoreGood = ((score <= 79 && score >= 60) || (isMaxScoreFive && score === 4));
  const isScoreMedium = ((score <= 59 && score >= 40) || (isMaxScoreFive && score === 3));
  const isScorePoor = ((score <= 39 && score >= 20) || (isMaxScoreFive && score === 2));
  const isScoreBad = ((score <= 19 && score >= 0 && score !== null) || (isMaxScoreFive && score < 2));
  if (isScoreMaximum) {
 return SCORE_MAX;
}
  if (isScoreGood) {
 return SCORE_GOOD;
}
  if (isScoreMedium) {
 return SCORE_MEDIUM;
}
  if (isScorePoor) {
 return SCORE_POOR;
}
  if (isScoreBad) {
 return SCORE_BAD;
}
  return '';
};

export const truncateText = (text, maxLength, tooltipPosition = null) => {
  if (!text || text.length <= maxLength) {
 return text;
}
  const fillSymbols = '...';
  const lengthToPad = maxLength + fillSymbols.length;
  const slicedText = text.slice(0, maxLength);
  const formattedText = slicedText.padEnd(lengthToPad, fillSymbols);
  if (!tooltipPosition) {
 return formattedText;
}
  return (
    <Tooltip tooltipText={text} delayHide={200} place={tooltipPosition || 'top'}>
      <span>{formattedText}</span>
    </Tooltip>
  );
};
